import { parseSizeUnit } from './dom.js'

import type { ShopifyImageSizeOptions } from '../types/index.js'

/**
 * Set page count and other search parameters to an
 * @param url
 * @param page
 * @param searchParameter
 * @returns
 */
export const setPageAndSearchParameters = (
  url: URL,
  page = 1,
  searchParameter?: URLSearchParams,
) => {
  if (page) url.searchParams.set('page', page.toString())
  // Append additional search parameters
  if (searchParameter) {
    searchParameter.forEach((value, key) => {
      const values = searchParameter.getAll(key)
      // If the search parameter exists multiple times, append all (this is needed for filters)
      if (values.length > 1) {
        url.searchParams.delete(key)
        for (const value of values) {
          url.searchParams.append(key, value)
        }
      } else {
        url.searchParams.set(key, value)
      }
    })
  }

  return url
}

export const setShopifyImageSize = (
  originalSrc: string,
  _width?: number | string,
  _height?: number | string,
  options: ShopifyImageSizeOptions = {},
) => {
  let src = originalSrc
  const url = new URL(originalSrc, window.location.origin)

  let width: number | undefined
  let height: number | undefined

  if (_width) {
    const { val } = parseSizeUnit(_width)
    width = val
  }

  if (_height) {
    const { val } = parseSizeUnit(_height)
    height = val
  }

  if (options.aspectRatio) {
    if (!height && width) {
      height = Math.round(width / options.aspectRatio)
    }
    if (!width && height) {
      width = Math.round(height * options.aspectRatio)
    }
  }

  if (width) {
    if (width > 5760) {
      console.warn(`[ShopifyImageSrcBinder] The max image width is 5760px!`)
      width = 5760
    }

    url.searchParams.set('width', width.toString())
  }
  if (height) {
    if (height > 5760) {
      console.warn(`[ShopifyImageSrcBinder] The max image height is 5760px!`)
      height = 5760
    }

    url.searchParams.set('height', height.toString())
  }

  if (options.crop) {
    url.searchParams.set('crop', options.crop)
  }

  src = url.toString()

  return src
}
